import React from "react";
import { Box } from "@mui/material";

/**
 * PageContainer — wraps page body content. Centered, max-width, standard padding.
 *
 * Props:
 *   maxWidth: "sm" | "md" | "lg" | "xl" | "full" | number (default "xl" = 1280px)
 */

const WIDTHS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  full: null,
};

function PageContainer({ maxWidth = "xl", children, sx, ...rest }) {
  const resolved =
    typeof maxWidth === "number" ? maxWidth : WIDTHS[maxWidth] ?? WIDTHS.xl;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: resolved || "none",
        mx: "auto",
        px: { xs: "16px", md: "32px" },
        py: "24px",
        ...(sx || {}),
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default PageContainer;
